'use client'

import { createBrowserClient } from '@vagahub/db/browser'
import { useEffect } from 'react'

export function PwaManager() {
  useEffect(() => {
    // 1. Registro do Service Worker
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('Service Worker registrado com sucesso:', registration.scope)
          // Sprint K: detecta nova versão disponível
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing
            if (!newWorker) return
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                window.dispatchEvent(new CustomEvent('pwa-update-available'))
              }
            })
          })
        })
        .catch((error) => {
          console.error('Falha ao registrar o Service Worker:', error)
        })
    }

    // 2. Escuta de instalação do PWA (beforeinstallprompt)
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault()
      // Disparar evento customizado no window para que o PwaInstallBanner possa capturar
      const installEvent = new CustomEvent('pwa-beforeinstallprompt', { detail: e })
      window.dispatchEvent(installEvent)
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

    // 3. Monitoramento de Logout com Supabase para limpeza de cache
    const supabase = createBrowserClient()

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT' || (event === 'INITIAL_SESSION' && !session)) {
        if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({ type: 'CLEAN_CACHE' })
          console.log('Mensagem de limpeza de cache enviada ao Service Worker devido a logout')
        }
      }
    })

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
      subscription.unsubscribe()
    }
  }, [])

  return null
}
export default PwaManager
